import {getMethod} from '~/api'

async function get(b2cId) {
    return await getMethod(`/api/b2cSettings/${b2cId}/b2cKey`)
}

export {get}
